import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@metarouter-private/mr-mui';

export default function ConfirmDeleteMessage({ clusterName, isDeployed }) {
  if (!isDeployed) {
    return null;
  }

  return (
    <Typography variant="body1" color="text.secondary">
      This pipeline is attached to the{' '}
      <Typography fontWeight="700" component="span">
        {clusterName}
      </Typography>{' '}
      cluster. If you choose to delete this pipeline, it will also be removed from the cluster. Integration playbooks
      used by this pipeline will not be affected. This pipeline will lose any pipeline-level transformations, filters,
      or pipeline variables attached to it.
    </Typography>
  );
}

ConfirmDeleteMessage.propTypes = {
  clusterName: PropTypes.string.isRequired,
  isDeployed: PropTypes.bool.isRequired,
};
